import animationObserver from './animationObserver';
const els = document.querySelectorAll('.js-animation-observer');

for (let el of els) {
    const opts = JSON.parse(el.getAttribute('data-animation-observer-opts'));

    animationObserver(el, opts);
}
